import { mapRoutes } from "./utils";

export default [
  /*
  |--------------------------------------------------------------------------
  | Guest Routes
  |--------------------------------------------------------------------------
  |
  | Here is where you can register routes for guest access. These
  | routes require not being authenticated and are public
  | access.
  |
  */

  ...mapRoutes({ onlyWhenLoggedOut: true }, [
    {
      path: "/",
      name: "home",
      component: () => import(/* webpackChunkName: 'home' */ "@/views/Home"),
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: 'login' */ "@/views/auth/Login"),
    },
    {
      path: "/redirect",
      name: "redirect",
      component: () =>
        import(/* webpackChunkName: 'redirect' */ "@/views/auth/Redirect"),
    },
    {
      path: "/register",
      name: "register",
      component: () =>
        import(/* webpackChunkName: 'register' */ "@/views/auth/Register"),
    },
    {
      path: "/account-confirmation",
      name: "account-confirmation",
      component: () =>
        import(
          /* webpackChunkName: 'account-confirmation' */ "@/views/auth/AccountConfirmation"
        ),
    },
    {
      path: "/password/email",
      name: "password.email",
      component: () =>
        import(/* webpackChunkName: 'email' */ "@/views/auth/password/Email"),
    },
    {
      path: "/password/reset/:token",
      name: "password.reset",
      component: () =>
        import(/* webpackChunkName: 'reset' */ "@/views/auth/password/Reset"),
    },
  ]),

  /*
  |--------------------------------------------------------------------------
  | Protected Routes
  |--------------------------------------------------------------------------
  |
  | Here is where you can register routes for private access. These
  | routes require authentication and are used for private
  | access.
  |
  */

  {
    path: "/profile",
    name: "profile",
    component: () =>
      import(/* webpackChunkName: 'profile' */ "@/views/Profile"),
  },
  {
    path: "/cops/add",
    name: "cop-add",
    component: () =>
      import(/* webpackChunkName: 'cop-add' */ "@/views/cops/Add"),
  },
  {
    path: "/cops/:id/rating",
    name: "add-rating",
    component: () =>
      import(/* webpackChunkName: 'add-rating' */ "@/views/cops/AddRating"),
  },
  {
    path: "/forum/add",
    name: "post-add",
    component: () =>
      import(/* webpackChunkName: 'post-add' */ "@/views/forum/Add"),
  },

  /*
  |--------------------------------------------------------------------------
  | Public Routes
  |--------------------------------------------------------------------------
  |
  | Here is where you can register routes for public access. These
  | routes do not require authentication and are used by the entire
  | application.
  |
  */

  ...mapRoutes({ public: true }, [
    {
      path: "/about",
      name: "about",
      component: () => import(/* webpackChunkName: 'about' */ "@/views/About"),
    },
    {
      path: "/stations",
      name: "stations",
      component: () =>
        import(/* webpackChunkName: 'stations' */ "@/views/Stations"),
    },
    {
      path: "/cops",
      name: "cops",
      component: () =>
        import(/* webpackChunkName: 'cops' */ "@/views/cops/Cops"),
    },
    {
      path: "/cops/:id",
      name: "cop",
      component: () => import(/* webpackChunkName: 'cop' */ "@/views/cops/Cop"),
    },
    {
      path: "/forum",
      name: "posts",
      component: () =>
        import(/* webpackChunkName: 'posts' */ "@/views/forum/Posts"),
    },
    {
      path: "/forum/:id",
      name: "post",
      component: () =>
        import(/* webpackChunkName: 'post' */ "@/views/forum/Post"),
    },
    {
      path: "/legal-services",
      name: "firms",
      component: () =>
        import(/* webpackChunkName: 'firms' */ "@/views/LegalServices"),
    },
    {
      path: "/terms-of-use",
      name: "terms",
      component: () => import(/* webpackChunkName: 'terms' */ "@/views/Terms"),
    },
    {
      path: "/privacy-policy",
      name: "privacy",
      component: () =>
        import(/* webpackChunkName: 'privacy' */ "@/views/Privacy"),
    },
  ]),

  /*
  |--------------------------------------------------------------------------
  | Error Routes
  |--------------------------------------------------------------------------
  |
  | Here is where you can register routes for error messages. These
  | routes are used when there is no match.
  |
  */

  ...mapRoutes({ public: true }, [
    {
      path: "*",
      name: "404",
      component: () =>
        import(/* webpackChunkName: '404' */ "@/views/errors/404"),
    },
  ]),
];
